<template>
  <div class="live live01">
    <div class="inner">
      <Title>
        <template #title>
          スタンプラリー企業ブース
        </template>
      </Title>
      <div class="description">
        <p>
          企業ブースを回って、スタンプラリー抽選会に参加しよう♪<br>
          抽選会では豪華商品が当たります！
        </p>
      </div>
      <div
        class="comingsoon"
        v-if="month === '202008'"
      >
        <figure>
          <img src="/img/logo.svg">
          <figcaption>
            COMING SOON<br>
            お楽しみに♪
          </figcaption>
        </figure>
      </div>
      <div v-else>
        <div class="live-programs"
        >
          <LiveProgram09
            v-for="(program, idx) in companyLive0915"
            :key="idx"
            :program="program"
            liveType="company"
            :month="month"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Title from '@/components/atoms/Title.vue'
import LiveProgram09 from '@/components/molecules/202009sendai/LiveProgram.vue'

export default {
  props: {
    month: {
      type: String,
      required: true
    }
  },
  components: {
    Title,
    LiveProgram09
  },
  data: () => ({
    companyLive: []
  }),
  computed: {
    ...mapState([
      'dateTab'
    ]),
    ...mapGetters([
      'companyLive0915'
    ])
  },
  methods: {
    // async infiniteHandler ($state) {
    //   await this.getCompanyLivePrograms({
    //     month: this.month
    //   })
    //     .then(() => {
    //       this.setLive()
    //       $state.loaded()
    //     })
    //     .catch(() => {
    //       $state.complete()
    //     })
    // },
  }
}
</script>

<style lang="sass" scoped>
.live01
  padding: 20px 0 25px
</style>
